module.exports = __webpack_public_path__ + "img/xcx.a5aaec6f.png";